import { formatDate, MOMENT_FORMATS } from '../../../utils/dateFormat';
import { isEventDatePast } from '../../Events/ManageEvent/eventTimeUtils';
import { isAttendanceFinalized } from './attendanceFinalizeUtils';

const WORKFLOW_ACTIVE_STATUSES = new Set(['approved', 'published', 'live']);

/** Display label for archived-at, e.g. "Aug 26, 2026". */
export const formatPartnerEventArchivedAt = (deletedAt) =>
  formatDate(deletedAt, MOMENT_FORMATS.DATE);

/** Workflow status from event `status`. */
export const getPartnerEventStatus = (event) => String(event?.status ?? '').toLowerCase();

export const isPartnerEventArchived = (event) => Boolean(event?.deletedAt);

export const isPartnerEventPublished = (event) => Boolean(event?.published);

export const resolvePartnerApprovalStatus = (event) => {
  if (isPartnerEventArchived(event)) {
    return 'archived';
  }

  const status = getPartnerEventStatus(event);
  if (status === 'archived' || status === 'completed') {
    return status;
  }

  const eventDate = event?.eventDate;
  const past = isEventDatePast(eventDate);

  if (past && WORKFLOW_ACTIVE_STATUSES.has(status)) {
    return 'completed';
  }

  if (isPartnerEventPublished(event) && !past && WORKFLOW_ACTIVE_STATUSES.has(status)) {
    return 'live';
  }

  return status;
};

export const isPartnerEventCompleted = (event) =>
  resolvePartnerApprovalStatus(event) === 'completed';

const canPartnerAttendanceOnPastEvent = (event, requireFinalized) => {
  if (isPartnerEventArchived(event)) {
    return false;
  }
  const finalized = isAttendanceFinalized(event);
  if (requireFinalized ? !finalized : finalized) {
    return false;
  }
  if (!WORKFLOW_ACTIVE_STATUSES.has(getPartnerEventStatus(event))) {
    return false;
  }
  return isEventDatePast(event?.eventDate);
};

export const canPartnerFinalizeAttendance = (event) =>
  canPartnerAttendanceOnPastEvent(event, false);

export const canPartnerViewAttendance = (event) => canPartnerAttendanceOnPastEvent(event, true);

export const canArchivePartnerEvent = (event) => {
  if (isPartnerEventArchived(event) || isPartnerEventCompleted(event)) {
    return false;
  }
  return !isEventDatePast(event?.eventDate);
};

export const shouldHidePartnerEventTimeline = (event) => isPartnerEventArchived(event);

export const shouldHidePartnerEventStatistics = (event) => isPartnerEventArchived(event);
